import {
  Component,
  inject,
  Input,
  ChangeDetectionStrategy,
} from "@angular/core";
import { IconComponent } from "@claas/claas-ui-components";
import { TranslatePipe } from "@ngx-translate/core";
import { ConfigService } from "../../../config/config.service";

@Component({
  selector: "claas-support-documents",
  imports: [TranslatePipe, IconComponent],
  templateUrl: "./support-documents.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./support-documents.scss",
})
export class SupportDocuments {
  @Input()
  tableData: {
    id: string;
    name: string;
    language: string;
    format: string;
    size: string;
    path: string;
  }[] = [];

  configService = inject(ConfigService);

  async handleDownloadLinkClick(route: string, evt: MouseEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    const anchor = evt.currentTarget as HTMLAnchorElement;

    const outsideRes = await fetch(route);

    const blob = await outsideRes.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = anchor.hasAttribute("download")
      ? (anchor.getAttribute("download") as string)
      : (anchor.getAttribute("data-download") as string);
    link.click();
  }
}
